import { FC } from "react";
import classNames from "classnames";

import Skeleton from "../../Skeleton/Skeleton";

import styles from "./OverviewSourceUsageSkeleton.module.css";
import tableStyles from "../../SourceTable/SourceTable.module.css";

const CHART_HEIGHT = 330;
const LEGEND_ITEMS = 5;
const TABLE_ROWS = 5;
const TABLE_COLUMNS = 7;

const OverviewSourceUsageSkeleton: FC<{ className?: string }> = ({
  className,
}) => (
  <div
    className={classNames(styles["overview_source_usage_skeleton"], className)}
    aria-busy="true"
    aria-label="Loading source usage"
  >
    <div className={styles["overview_source_usage_skeleton__legend"]}>
      {Array.from({ length: LEGEND_ITEMS }).map((_, i) => (
        <div
          key={i}
          className={styles["overview_source_usage_skeleton__legend_item"]}
        >
          <Skeleton
            width={20}
            height={20}
            className={styles["overview_source_usage_skeleton__legend_swatch"]}
          />
          <Skeleton height={16} width={72} variant="text" />
        </div>
      ))}
    </div>

    <div className={styles["overview_source_usage_skeleton__chart"]}>
      <Skeleton height={CHART_HEIGHT} variant="text" />
    </div>

    <div className={styles["overview_source_usage_skeleton__table"]}>
      <table className={tableStyles["source_table"]}>
        <thead>
          <tr className={tableStyles["source_table__header_row"]}>
            <th><Skeleton height={20} width={24} variant="text" /></th>
            <th><Skeleton height={20} width={80} variant="text" /></th>
            <th><Skeleton height={20} width={90} variant="text" /></th>
            <th><Skeleton height={20} width={60} variant="text" /></th>
            <th><Skeleton height={20} width={56} variant="text" /></th>
            <th><Skeleton height={20} width={72} variant="text" /></th>
            <th aria-hidden><Skeleton height={32} width={32} /></th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: TABLE_ROWS }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className={tableStyles["source_table__body_row"]}
            >
              {Array.from({ length: TABLE_COLUMNS }).map((_, colIndex) => (
                <td key={colIndex}>
                  {colIndex === 0 ? (
                    <Skeleton height={24} width={20} variant="text" />
                  ) : colIndex === 1 ? (
                    <div className={tableStyles["source_table__source"]}>
                      <Skeleton
                        width={40}
                        height={40}
                        className={tableStyles["source_table__logo"]}
                      />
                      <Skeleton height={20} width={120} variant="text" />
                    </div>
                  ) : colIndex === TABLE_COLUMNS - 1 ? (
                    <Skeleton height={32} width={32} />
                  ) : (
                    <Skeleton height={24} width={48} variant="text" />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default OverviewSourceUsageSkeleton;
